import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link, useParams } from 'react-router-dom';

import { createUrl } from 'app/utils';
import usestorage from 'app/utils/storage';
import { Flex, Typography } from 'components';
import { useAuth } from 'features/auth';
import { useOffers } from 'features/offers';

const storage = usestorage('sessionStorage');

const LoginButton = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`;

const AccountName = styled(Flex)`
  ${({ theme: { mediaQueries } }) => {
    return `
      display: none;

      ${mediaQueries.desktop} {
        display: flex;
      }
  `;
  }}
`;

const Account = () => {
  const { isLogged, fullName } = useAuth();
  const { showLogin, checkout, setLogin } = useOffers();
  const { offerIdentifier } = useParams();

  const handleShowLogin = () => {
    storage.set('redirect_url', `/${window.location.pathname.substring(1)}${window.location.search}`);
    setLogin({ showLogin: true });
  };

  useEffect(() => {
    if (isLogged) {
      if (showLogin) setLogin({ showLogin: false, bypassLogin: true });
    }
  }, [isLogged]);

  const name = fullName || checkout.customerName;

  return (
    <Flex alignItems="center">
      <AccountName alignItems="center">
        {isLogged ? (
          <Typography type="type1" fontWeight="bold">
            {name.split(/(\s).+\s/).join('')}
          </Typography>
        ) : (
          <Typography type="type1" fontWeight="bold">
            Já é aluno?
          </Typography>
        )}
      </AccountName>

      {isLogged ? (
        <Link to={`${createUrl('logout')}?redirect=${createUrl('offers/payment', [offerIdentifier])}`}>
          <LoginButton>
            <Typography type="type1" color="primary_400" colorHover="primary_600" fontWeight="bold" upper ml={1}>
              Sair
            </Typography>
          </LoginButton>
        </Link>
      ) : (
        <Typography type="type1" fontWeight="bold">
          <LoginButton onClick={handleShowLogin}>
            <Typography type="type1" color="primary_400" colorHover="primary_600" fontWeight="bold" upper>
              Faça seu login
            </Typography>
          </LoginButton>
        </Typography>
      )}
    </Flex>
  );
};

export default Account;
